<template>
  <div class="chart-bar">
    <div class="title">
      <span>{{ title }}</span>
      <div>
        <ElementSelect
          :options="tabList"
          :val="tabIndex"
          @val="
            (e) => {
              tabIndex = e;
            }
          "
        />
      </div>
    </div>
    <div class="chart-con">
      <div class="flex-end">
        <ElementSelect
          :placeholder="'请选择产业'"
          multiple
          collapse-tags
          :options="cyOptions"
          :multiple-limit="5"
          :val="cyIndex"
          @val="
            (e) => {
              cyIndex = e;
            }
          "
        />
      </div>
      <div class="chart-pie">
        <v-chart ref="bar-chart" :id="chartId" class="bar-chart" :options="chartOption" />
        <div :class="['chart-legend']">
          <div class="legend-list3">
            <div class="legend-item" v-for="(item, i) in chartData.names" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': colors[i] }"
                  ><i :style="{ 'border-color': colors[i] }"></i
                ></span>
                <el-tooltip effect="dark" placement="top" v-if="item && item.length > 6">
                  <span>
                    {{ item ? item : '-' }}
                  </span>
                  <div slot="content">
                    {{ item ? item : '-' }}
                  </div>
                </el-tooltip>
                <span v-else>
                  {{ item ? item : '-' }}
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="pager-box" v-if="!tabIndex">
          <i :class="['el-icon-caret-top', { dis: pager.current <= 1 }]" @click="changePage(false)"></i>
          <div>
            {{ pager.current }}
            <span> / {{ pager.total }} </span>
          </div>
          <i :class="['el-icon-caret-bottom', { dis: pager.current >= pager.total }]" @click="changePage(true)"></i>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawBar from '../chartJs/bar';
import { getBarData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import ElementSelect from '../../../components/element-select';
import echarts from 'echarts';
import drawLine from '../chartJs/PELine';
import tmpData from '@/views/home/tmpData';
const colors = [
  '#00C9FF',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  '#aae6ff',
];
export default {
  name: 'ChartBar',
  components: { TabList, ElementSelect },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    apiName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      colors,
      chartOption: null,
      chartData: null,
      cyOptions: [],
      cyIndex: [],
      tabList: [
        {
          value: 0,
          label: '行业',
        },
        {
          value: 1,
          label: '产业',
        },
      ],
      tabIndex: 0,
      year: 2021,
    };
  },
  watch: {
    tabIndex() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    cyIndex() {
      this.$nextTick(() => {
        this.getData();
      });
    },
  },
  methods: {
    getData() {
      let data = tmpData['广东省民营经济生产总值变化趋势'];
      let arr = data.filter((y) => (this.tabIndex ? y['一级指标'] === '产业' : y['一级指标'] === '行业'));

      let tmpOption = arr.map((x) => x['二级指标']);
      this.cyOptions = tmpOption
        .filter((item, index) => {
          return tmpOption.indexOf(item) === index;
        })
        .map((x) => ({
          value: x,
          label: x,
        }));
      if (!this.cyIndex.length || !this.cyOptions.find((x) => x.value === this.cyIndex[0]))
        this.cyIndex = this.cyOptions.slice(0, 5).map((x) => x.value);
      let arrFilter = arr.filter((x) => this.cyIndex.indexOf(x['二级指标']) >= 0);
      let arrNew = [];
      arrFilter.map((x) => {
        let index = arrNew.findIndex((y) => y['年份'] === x['年份']);
        console.log(x, index, arrNew);
        if (index === -1) {
          let t = {};
          t['年份'] = x['年份'];
          (t[x['二级指标']] = x['数值']), arrNew.push(t);
        } else {
          arrNew[index][x['二级指标']] = x['数值'];
        }
      });
      let list = {
        yAxis: {
          name: '单位：亿元',
        },
        names: this.cyIndex,
        // colorOpacity: true,
        data: arrNew,
      };
      this.chartData = list;
      this.chartOption = drawLine(list);
      return;

      if (!this.name) return;
      let chart = echarts.init(document.getElementById(this.chartId));
      this.$api.screen[this.apiName]({
        endYear: this.yearP,
      }).then((res) => {
        let { data } = res.data;
        let names = [],
          listData = {};
        if (data && data.yData?.length) {
          names = data.yData.map((item) => {
            listData[item.name] = item.data;
            return item.name;
          });
          listData['年份'] = data.xData;
        }
        let list = {
          yAxis: {
            name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元'),
          },
          names: ['总数'],
          // colorOpacity: true,
          data: [],
        };
        if (this.type === 'multi') {
          list.names = names;
          list.showLabel = this.showLabel;
        }
        for (let i = 0; i < data.xData.length; i++) {
          let obj = {
            年份: data.xData[i],
          };
          for (let key in listData) {
            obj[key] = listData[key][i];
          }
          list.data.push(obj);
        }
        this.chartData = list;
        this.chartOption = drawLine(list);

        let _this = this;
        chart.on('click', function (params) {
          _this.$emit('click-chart', params);
        });
      });

      // getBarData(this.name).then(res => {
      //   let year = new Set();
      //   let names = new Set();
      //   let data = [];
      //   res.RECORDS.map((item) => {
      //     year.add(item['年份']);
      //     names.add(item['指标']);
      //     data.push(item['总数'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元')
      //       },
      //       names: ['总数'],
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let dataObj = {};
      //     year = Array.from(year)
      //     dataObj.year = year;
      //     if (this.type === 'multi') {
      //       names = Array.from(names);
      //       list.names = names;
      //       list.showLabel = this.showLabel;
      //       dataObj.private = this.filterData(res.RECORDS, names[0], '总数', '指标');
      //       dataObj.individual = this.filterData(res.RECORDS, names[1], '总数', '指标');
      //       for (let i = 0; i < dataObj.year.length; i++) {
      //         let obj = {
      //           年份: year[i],
      //         };
      //         obj[names[0]] = dataObj.private[i];
      //         obj[names[1]] = dataObj.individual[i];
      //         list.data.push(obj)
      //       }
      //       this.chartData = list;
      //       this.chartOption = drawBar(list)
      //       return;
      //     }
      //     for (let i = 0; i < year.length; i++) {
      //       list.data.push({
      //         年份: year[i],
      //         总数: data[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.chart-bar {
  .chart-box();
  .title {
    width: 100%;
    div {
      flex: 1;
      justify-content: flex-end;
      display: inline-flex;
      line-height: 1;
      align-items: center;
      .element-select {
        position: unset;
      }
    }
    #btn-link {
      margin-left: 32px;
    }
  }
  .flex-end {
    justify-content: flex-end;
    display: flex;
    padding-top: 6px;
    /deep/.element-select .el-select {
      width: 290px;
    }
  }
  .bar-chart {
    width: calc(100% - 200px);
  }
  .chart-pie {
    display: flex;
    height: 100%;
  }
  .chart-legend {
    width: 200px;
    /*width: 50%;*/
    color: #fff;
    height: 200px;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    // max-height: 160px;
    overflow: hidden;
    //.show-scroll-bg-trans();

    &.chart3d {
      justify-content: center;
      max-height: 200px;

      .legend-item {
        line-height: 30px;
        margin-bottom: 20px;
      }
    }

    .legend-list3 {
      width: 100%;
      height: calc(100% - 20px);
      transition: all 0.3s;
    }

    .pager-box {
      position: absolute;
      right: 0;
      bottom: 10px;
      .flex-center();
      padding-right: 10px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #87e6ff;
      line-height: 38px;

      div {
        letter-spacing: -2px;
        margin: 0 10px;

        span {
          color: rgba(135, 230, 255, 0.3);
        }
      }

      i {
        margin-top: 2px;
        cursor: pointer;

        &.dis {
          color: rgba(135, 230, 255, 0.3);
          cursor: not-allowed;
        }
      }
    }

    .legend-item {
      .flex-center();
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      /*line-height: 20px;*/
      margin-bottom: 10px;

      &:first-child {
        margin-top: 10px;
      }

      .name {
        width: 150px;
        .flex-center();

        span:last-child {
          width: calc(100% - 21px);
          .ellipsis();
        }
      }
    }

    .color {
      position: relative;
      width: 16px;
      height: 2px;
      margin-right: 6px;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        background: #ffffff;
        border: 2px solid #00c9ff;
        border-radius: 50%;
        display: inline-block;
      }
    }

    .num {
      width: 80px;
      font-size: 20px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #fff;
      line-height: 30px;
      margin: 0 5px 0 20px;
      text-align: right;
    }

    .unit {
      font-size: 12px;
    }
  }
}
</style>
